import { Input, Button, Icon, Divider, Popconfirm } from 'antd'

import React, { useLayoutEffect, useState } from 'react'
import { FormattedMessage, useIntl, FormattedHTMLMessage } from 'react-intl'
import ProgressGuideView from '../../../components/ProgressGuideView'
import PackKeyTextForm, {
  PackKeyTextGuide,
} from '../../../components/PackKeyTextForm'

import { PackageInfo, PackageInfoForm, SetUndefined } from '../../../types'
import { filterMultiLangInfos } from '../../../utils/multiLangInfo'
import PackMultiLangInfoForm from '../../../components/PackMultiLangInfoForm'
import PackLangSelect from '../../../components/upload/info/PackLangSelect'

import useUploadPackageInfo from '../../../hooks/upload/useUploadPackageInfo'
import randomHexString from '../../../utils/getRandomHexString'
import { makeDefaultPostPackageInfo } from '../../../utils/makeDefaultPackageInfo'
import { toFormData } from '../../../utils/uploadPackageInfoUtils'

import emptyThumbnailImage from '../../../img/group-7.png'
import { useUserWithRedirect } from '../../../hooks/user/useUserWithRedirect'
import { useResetPackageLang } from '../../../hooks/reactQuery/usePackage'
import checkPlusPackChangeLangPossible from '../../../utils/checkPlusPackChangeLangPossible'
import { notiFormForError } from '../../../components/notificationForm'
type UploadPackageInforProp = {
  packageAndSticker: PackageInfo
}
export default function UploadPackageInfoForm({
  packageAndSticker,
}: UploadPackageInforProp) {
  const curUser = useUserWithRedirect()
  const { checkRequireFeild, createPackage, updatePackage, checkThumnail } =
    useUploadPackageInfo(packageAndSticker.objectId)
  const [newThumbnailUrl, setNewThumbnailUrl] = useState<string | null>(null)
  const mutateResetLang = useResetPackageLang(packageAndSticker?.objectId)

  const handleThumbnailInput = async (
    e: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const eventTarget = e.target

    if (!eventTarget.files) {
      return
    }
    let file = eventTarget.files[0]
    const blob = file.slice(0, -1, 'image/png')

    file = new File([blob], randomHexString(10), { type: 'image/png' })

    const objUrl = await checkThumnail(file)
    //썸네일이 조건이 안맞음 크거나 사이즈가 별로거나
    if (!objUrl) return

    setPackageInfo({ ...packageInfo, thumbnail: file })

    //그전에 올린 썸네일이 있고 objecturl 로 만들었으면 삭제한다.
    if (newThumbnailUrl) {
      window.URL.revokeObjectURL(newThumbnailUrl)
    }
    setNewThumbnailUrl(objUrl)
  }
  const [packageInfo, setPackageInfo] = useState<PackageInfoForm>(
    makeDefaultPostPackageInfo({}),
  )
  const isUpdatePackagePage = packageAndSticker?.objectId !== ''

  const isPackTextLangChanged =
    packageInfo.packType === 'PLUS' &&
    packageInfo.textLang !== packageAndSticker?.textLang

  const handleSubmit = () => {
    if (!curUser) return
    if (!packageAndSticker) return
    if (!checkRequireFeild(packageInfo, isUpdatePackagePage)) return
    if (
      // 패키지를 생성중인 샃태
      packageAndSticker.objectId !== '' &&
      isPackTextLangChanged &&
      !checkPlusPackChangeLangPossible(packageAndSticker)
    ) {
      notiFormForError(
        intl.locale,
        intl.formatMessage({
          id: 'Upload.PkgCreation.createPack.langchange.error',
        }),
      )
      return
    }

    // const packageInfoWithTream = { ...packageInfo }
    for (let [key, value] of Object.entries(packageInfo.name)) {
      packageInfo.name[key] = value.trim()
    }

    const formData = isUpdatePackagePage
      ? //update 할때는 movingstatus 를 주면 안됨
        toFormData<SetUndefined<PackageInfoForm, 'movingStatus'>>({
          ...packageInfo,
          movingStatus: undefined,
        })
      : toFormData<PackageInfoForm & { author: string }>({
          ...packageInfo,
          author: curUser.objectId,
        })

    const packageId = packageAndSticker.objectId

    if (packageId === '') {
      createPackage(formData, curUser.sessionToken)
    } else {
      updatePackage(formData, packageId, curUser.sessionToken)
      if (isPackTextLangChanged) {
        mutateResetLang.mutate({
          packageId,
          sessionToken: curUser.sessionToken,
        })
      }
    }
  }

  const clickSubmitButton = () => {
    // pack 의 textLang 이 변했으면 pop confirm 에서 확인을 해야 제출가능하다.
    if (isUpdatePackagePage && isPackTextLangChanged) return
    handleSubmit()
  }
  const clickSubmitConfirmButton = () => {
    handleSubmit()
  }
  //이값으로 만드는 중인 패키지와 만들기전인 패키지를 구분할 것
  // const { packageAndSticker, error, mutate } = usePackageAndEmoticon(packageId)

  // local 로 복사

  useLayoutEffect(() => {
    if (packageAndSticker) {
      // put post 시에 필요한 데이터만 local 값에 복사해서 저장한다
      const packageInfoKey = Object.keys(packageInfo)
      const newPackageInfo: any = { ...packageInfo }
      for (const [key, value] of Object.entries(packageAndSticker)) {
        if (packageInfoKey.includes(key)) {
          newPackageInfo[key] = value
        }
      }
      setPackageInfo(newPackageInfo)
    }
  }, [packageAndSticker])
  const intl = useIntl()
  const otherNames = filterMultiLangInfos(packageInfo.name)

  const otherDescriptions = filterMultiLangInfos(packageInfo.description)

  const getThumburl = () => {
    if (newThumbnailUrl) {
      return newThumbnailUrl
    } else if (packageAndSticker && packageAndSticker.thumbnail.url !== '') {
      return packageAndSticker.thumbnail.url
    }
    return emptyThumbnailImage
  }
  if (!curUser) {
    return <></>
  }
  return (
    <>
      <div className="creation-pack-with-type">
        <div className="creation-pack-with-type-thumbnail-box">
          <div className="creation-pack-with-type-thumbnail-title">
            <span style={{ color: 'red' }}>*</span>
            <FormattedMessage
              id="Upload.PkgCreation.createPack.thumbnail.title"
              defaultMessage="Pack Thumbnail"
            />
            <ProgressGuideView step="package-info" language={intl.locale} />
          </div>
          <div className="creation-pack-with-type-thumbnail">
            <img
              className="creation-pack-with-type-thumbnail-cover"
              src={getThumburl()}
              alt=""
            />
            <label
              className="creation-pack-with-type-hover-effect-wrapper"
              htmlFor="file-input"
            >
              <span className="darkness" />
              <Icon type="edit" className="hover-icon" />
              <input
                name="thumbnail"
                id="file-input"
                type="file"
                style={{ display: 'none' }}
                accept=".png"
                onChange={handleThumbnailInput}
              />
            </label>
          </div>
        </div>
        <div className="creation-pack-with-type-info">
          <Divider style={{ margin: '0px' }} />
          <div className="creation-pack-with-type-info-pack-type-box">
            <div className="creation-pack-with-type-input-label-box">
              <div className="creation-pack-with-type-input-label">
                <FormattedMessage
                  id="Upload.PkgCreation.createPack.packType"
                  defaultMessage="Pack Type"
                />
              </div>
            </div>
            <div className="creation-pack-with-type-input-value-box">
              {packageInfo.packType ? (
                <div className={`pack-type-badge-${packageInfo.packType}`}>
                  <FormattedMessage
                    id={`Upload.PkgCreation.createPack.packType.${packageInfo.packType}`}
                    defaultMessage=" "
                  />
                </div>
              ) : (
                <FormattedMessage
                  id={'Upload.PkgCreation.createPack.packType.undefined'}
                  defaultMessage="No type"
                />
              )}
              {packageInfo.movingStatus && (
                <FormattedMessage
                  id={`Upload.PkgCreation.createPack.packType.${packageInfo.movingStatus.toLowerCase()}`}
                  defaultMessage=" "
                />
              )}
            </div>
          </div>
          <Divider style={{ margin: '0px' }} />
          <div className="creation-pack-with-type-info-pack-name-box">
            <div className="creation-pack-with-type-input-label-box">
              <div className="creation-pack-with-type-input-label">
                <span style={{ color: 'red' }}>*</span>
                <FormattedMessage
                  id="Upload.PkgCreation.createPack.packName"
                  defaultMessage="Pack Name"
                />
              </div>
              <div className="creation-pack-with-type-input-label-caption">
                (Only English)
              </div>
            </div>
            <div className="creation-pack-with-type-input-value-box">
              <Input
                className="creation-pack-with-type-input-box-pack-name"
                name="name"
                value={packageInfo.name.en}
                onChange={(e) =>
                  setPackageInfo({
                    ...packageInfo,
                    name: { ...packageInfo.name, en: e.target.value },
                  })
                }
              />
            </div>
          </div>
          <div className="creation-pack-with-type-info-pack-description-box">
            <div className="creation-pack-with-type-input-label-box">
              <div className="creation-pack-with-type-input-label">
                <span style={{ color: 'red' }}>*</span>
                <FormattedMessage
                  id="Upload.PkgCreation.createPack.packDescription"
                  defaultMessage="Pack Description"
                />
              </div>
              <div className="creation-pack-with-type-input-label-caption">
                (Only English)
              </div>
            </div>
            <div className="creation-pack-with-type-input-pack-description-box">
              <Input.TextArea
                className="creation-pack-with-type-input-box-pack-description"
                name="packDescription"
                value={packageInfo.description.en}
                onChange={(e) =>
                  setPackageInfo({
                    ...packageInfo,
                    description: {
                      ...packageInfo.description,
                      en: e.target.value,
                    },
                  })
                }
              />

              <div className="creation-pack-with-type-pack-value-caution">
                <FormattedMessage
                  id="Upload.PkgCreation.createPack.packDescription.caution"
                  defaultMessage="Please check the pack name and description for typos and morally or ethically inappropriate words."
                />
              </div>
            </div>
          </div>
          <Divider style={{ margin: '0px' }} />
          {/* 다른 언어의 제목이나 설명 */}

          <PackMultiLangInfoForm
            key={Object.keys(otherNames).toString()}
            names={otherNames}
            descriptions={otherDescriptions}
            isEditing={false}
            setNames={(names: any) => {
              setPackageInfo((packageInfo) => ({
                ...packageInfo,
                name: {
                  en: packageInfo.name.en,
                  ...names,
                },
              }))
            }}
            disabledName={false}
            setDescriptions={(description: any) =>
              setPackageInfo((packageInfo) => ({
                ...packageInfo,
                description: {
                  en: packageInfo.description.en,
                  ...description,
                },
              }))
            }
            disabledDescription={false}
          />

          {/* package text lang 선택 */}
          {packageInfo.packType === 'PLUS' && (
            <PackLangSelect
              packageInfo={packageInfo}
              setPackageInfo={setPackageInfo}
            />
          )}

          <div className="creation-pack-with-type-pack-extrainfo">
            <div className="creation-pack-with-type-pack-extrainfo-label-box">
              <div className="creation-pack-with-type-pack-extrainfo-label">
                <span style={{ color: 'red' }}>*</span>
                <FormattedMessage
                  id="Upload.PkgCreation.createPack.packKeyword"
                  defaultMessage="Pack keyword"
                />
                <PackKeyTextGuide />
              </div>
              <div className="creation-pack-with-type-input-label-caption">
                (Only English)
              </div>
            </div>
            <div className="creation-pack-with-type-pack-extrainfo-value">
              <PackKeyTextForm
                keyTexts={packageInfo.keyTexts}
                setKeyTexts={(keyTexts: string[]) =>
                  setPackageInfo({ ...packageInfo, keyTexts })
                }
              />
              <div className="creation-pack-with-type-pack-value-caution">
                <FormattedHTMLMessage
                  id="Upload.PkgCreation.createPack.packKeyword.caution"
                  defaultMessage="Please list the topic and style of the pack as keyword tags for the pack search. You can register up to 10 keywords. Keywords that are not related to the pack may be excluded from future searches."
                />
              </div>
            </div>
          </div>
          <div>
            {packageInfo.packType === 'PLUS' &&
            isUpdatePackagePage &&
            packageInfo.textLang !== packageAndSticker?.textLang ? (
              <Popconfirm
                placement="top"
                title={
                  <div style={{ width: 'max-content', margin: 0 }}>
                    <FormattedHTMLMessage
                      id="Upload.PkgCreation.createPack.popconfirm.message"
                      defaultMessage="<b>Final Check Before Submission</b><div>Before you click the submit button, please make sure there is<br/>nothing to correct. After submission, you cannot modify pack<br/>introductions, stickers or tags unless the pack is rejected!</div>"
                    />
                  </div>
                }
                onConfirm={() => {
                  clickSubmitConfirmButton()
                }}
                okText={
                  <FormattedMessage
                    id="Upload.PkgCreation.createPack.popconfirm.ok"
                    defaultMessage="OK"
                  />
                }
                cancelText={
                  <FormattedMessage
                    id="Upload.PkgCreation.createPack.popconfirm.cancel"
                    defaultMessage="Cancel"
                  />
                }
                icon={
                  <Icon
                    type="exclamation-circle"
                    theme="filled"
                    style={{ marginTop: 3 }}
                  />
                }
              >
                <Button
                  className="btn-style-primary"
                  onClick={clickSubmitButton}
                  style={{
                    fontSize: 16,
                    float: 'right',
                    margin: '64px 25px 59px 0px',
                  }}
                >
                  <FormattedMessage
                    id="Upload.PkgCreation.createPack.savebutton"
                    defaultMessage="Save"
                  />
                </Button>
              </Popconfirm>
            ) : (
              <Button
                className="btn-style-primary"
                onClick={clickSubmitButton}
                style={{
                  fontSize: 16,
                  float: 'right',
                  margin: '64px 25px 59px 0px',
                }}
              >
                <FormattedMessage
                  id="Upload.PkgCreation.createPack.savebutton"
                  defaultMessage="Save"
                />
              </Button>
            )}
          </div>
        </div>
      </div>
    </>
  )
}
